import {FormControl, FormGroup, Validators} from '@angular/forms';
import { DateValidators } from '../../../../shared/validators/date-validators';
import { SharedValidators } from '../../../../shared/validators/shared-validators';
import { AdminPanelUsersFormModel } from './admin-panel-users-form.model';
import { AdminPanelUsersValidators } from '../validators/admin-panel-users.validators';

export class AdminPanelUsersFormBuilder {
  static createFormGroup(
    hasExternalCriteria: () => boolean = () => false,
  ): FormGroup<AdminPanelUsersFormModel> {
    return new FormGroup<AdminPanelUsersFormModel>(
      {
        systemAdministrator: new FormControl<boolean>(false, {
          nonNullable: true,
        }),
        pesel: new FormControl<string | null>(null, [
          SharedValidators.peselValidator(),
        ]),
        firstName: new FormControl<string | null>(null, [
          AdminPanelUsersValidators.minLength(),
        ]),
        lastName: new FormControl<string | null>(null, [
          AdminPanelUsersValidators.minLength(),
        ]),
        documentNumber: new FormControl<string | null>(null, [
          AdminPanelUsersValidators.minLength(),
        ]),
        birthDate: new FormControl<Date | null>(null, [
          DateValidators.notInFuture(),
        ]),
        email: new FormControl<string | null>(null, [
          SharedValidators.emailValidator(),
        ]),
        city: new FormControl<string | null>(null),
        reason: new FormControl(null, [
          Validators.required
        ]),
      },
      {
        validators:
          AdminPanelUsersValidators.searchCriteria(hasExternalCriteria),
      },
    );
  }
}
